import { createSlice } from "@reduxjs/toolkit";
import { APIPartner, PartnerPatch } from "../../server/types/index.js";
import { Partner, PartnersState } from "../types/index.js";
import { fetch } from "../utils/utils.js";
import { showAlert } from "./alerts.js";
import { createAppAsyncThunk } from "./utils.js";

const sliceName = "partners";

const initialState: PartnersState = {};

export const getPartners = createAppAsyncThunk(
  `${sliceName}/getPartners`,
  async (siteId: string, { dispatch }) =>
    fetch({ dispatch })
      .get<APIPartner[]>(`sites/${siteId}/partners`)
      .then((res) => res.data),
  {
    condition: (_siteId: string, { getState }) =>
      getState().loadStates.partners === "unloaded",
  },
);

export const patchPartner = createAppAsyncThunk(
  `${sliceName}/patchPartner`,
  async (
    {
      siteId,
      partnerId,
      body,
    }: { siteId: string; partnerId: string; body: PartnerPatch },
    { dispatch },
  ) =>
    fetch({ dispatch })
      .patch<APIPartner>(`sites/${siteId}/partners/${partnerId}`, body)
      .then((res) => res.data)
      .catch((error) => {
        dispatch(
          showAlert(
            `Der Partner "${partnerId}" konnte nicht aktualisiert werden!`,
          ),
        );
        throw error;
      }),
);

const convertPartner = (partner: APIPartner): Partner => {
  const newPartner: Partner = {
    ...partner,
    logos: partner.logos.map((logo) => logo.id),
  };

  return newPartner;
};

const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPartners.fulfilled, (state, action) => {
      action.payload.forEach((partner) => {
        state[partner.id] = convertPartner(partner);
      });
    });
    builder.addCase(patchPartner.fulfilled, (state, action) => {
      state[action.payload.id] = convertPartner(action.payload);
    });
  },
});

export default slice.reducer;
